import { Controller } from "@hotwired/stimulus";
import { eventBus } from "../services/event_bus";

export class ConversationChatController extends Controller {
  static targets = ["list"];
  static values = {
    conversationId: String,
    avatarUrl: String,
  };

  connect() {
    this.onChatMessage = (event) => this.handleChatMessage(event.detail);
    eventBus.on("chat:message", this.onChatMessage);
  }

  disconnect() {
    eventBus.off("chat:message", this.onChatMessage);
  }

  handleChatMessage(payload) {
    if (payload.event !== "message.created") return;

    const message = payload.data?.message;

    if (!message) return;
    if (String(message.conversation_id) !== this.conversationIdValue) return;

    this.appendMessage(message);
  }

  appendMessage(message) {
    const lastMessage = this.listTarget.lastElementChild;
    const showAvatar =
      !lastMessage ||
      !lastMessage.classList.contains("conversations_messages--received");

    const row = document.createElement("div");
    row.classList.add(
      "conversations_messages",
      "conversations_messages--received",
    );

    const imageWrapper = document.createElement("div");
    imageWrapper.classList.add("conversations_messages-image");

    if (showAvatar) {
      const img = document.createElement("img");
      img.classList.add("conversations_messages-profile");
      img.src = this.avatarUrlValue;
      img.alt = "profile";
      imageWrapper.appendChild(img);
    }

    const container = document.createElement("div");
    container.classList.add("conversations_messages-container");

    const text = document.createElement("div");
    text.textContent = message.text;

    const hour = document.createElement("div");
    hour.classList.add("conversations_message-hour");

    const small = document.createElement("small");
    small.textContent = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    hour.appendChild(small);
    container.appendChild(text);
    container.appendChild(hour);

    row.appendChild(imageWrapper);
    row.appendChild(container);

    this.listTarget.appendChild(row);
    row.scrollIntoView({ block: "end" });
  }
}
